import { render, staticRenderFns } from "./prosess.vue?vue&type=template&id=3330309a"
import script from "./prosess.vue?vue&type=script&lang=js"
export * from "./prosess.vue?vue&type=script&lang=js"
import style0 from "./prosess.vue?vue&type=style&index=0&id=3330309a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports